import {Stage} from '../common/constant';

// @ts-ignore: Katal trick to replace env var.
// eslint-disable-next-line no-constant-condition
export const getStage = (): Stage => ('{{IsDev}}' === 'true' ? Stage.BETA : Stage.PROD);

export const getCareerSiteDomain = (): string =>
  __DEV__ ? 'https://gamma-us.devo.jobsatamazon.hvh.a2z.com' : 'https://hiring.amazon.com';
